const MENU_ITEMS_MAPPER = {
  insights: 'resumo',
  accounts: 'contas',
  charges: 'cobranças totais',
  myplan: 'meu plano',
  admin: 'administradores',
  staff: 'equipe',
  configuration: 'configurações',
  finance: 'gestão financeira',
  helpCenter: 'central de ajuda',
  staffUser: 'equipe',
  adminUser: 'administradores',
  invoices: 'meu plano',
  accountProduction: 'contas'
}
export { MENU_ITEMS_MAPPER }
